import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Card, Col, Row, FormGroup, Input, Progress, Button, CardHeader, Spinner, Tooltip, Modal, ModalHeader, ModalBody, ModalFooter, CardBody, Container } from 'reactstrap'
import { Link, useParams } from 'react-router-dom'
import Breadcrumb from '../../../layout/breadcrumb'
import AccountService from "../../../network/services/account"
import PammService from '../../../network/services/pammUploadFile'
import SweetAlert from 'sweetalert2'

import PammManagerStatistic from '../../../network/services/pammManagerStatistic'
import { useDispatch, useSelector } from 'react-redux'

import FilesService from '../../../network/services/files'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { FastForward, HelpCircle } from 'react-feather'

import "intro.js/introjs.css";
import { Steps, Hints } from 'intro.js-react';

import LPOA from './lpoa'
import PammAgreement from './pammAgree'

import './progress.scss'

const PammFollow = () => {
    const { t } = useTranslation()
    const { id } = useParams()
    const [accounts, setAccounts] = useState()
    const [error, setError] = useState(null)
    const { register, handleSubmit, errors, reset } = useForm()
    const [selectedAccount, setSelectedAccount] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const user = useSelector((state) => state.user)

    const userFullName = `${user?.user?.first_name ?? ''} ${user?.user?.last_name ?? ''}`



    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    })

    const [pammManagerDetails, setPammManagerDetails] = useState([])
    const [nextSettlementTooltipOpen, setNextSettlementTooltipOpen] = useState(false);
    const nextSettlementToggle = () => setNextSettlementTooltipOpen(!nextSettlementTooltipOpen);


    const [isSending, setIsSending] = useState(false)

    const { id: pammId } = useParams()



    const init = async () => {
        // live accounts
        setIsLoading(true)
        const result = await AccountService.getIdle()
        const pammResult = await PammManagerStatistic.get(id)
        setAccounts(result.idle)
        setPammManagerDetails(pammResult.details)
        setIsLoading(false)
    }

    useEffect(() => {
        init()
    }, [])

    const [openButton, SetOpenButton] = useState(false)



    const [stepsEnabled, setStepsEnabled] = useState(true)
    const steps = [
        {
            element: '#select-pamm-account',
            intro: t("pamm.ThisIsTheForm"),
        },
        {
            element: '#scroll-bottom',
            intro: t("pamm.PleaseMakeSureYouRead")
        },
        {
            element: '#name-input',
            intro: t("pamm.MakeSureYouTyped")
        }

    ]

    const onSubmit = async data => {

        setIsSending(true)

        const accountDetails = accounts.filter(account => account?.account_login == selectedAccount)
        const accountCredit = await AccountService.checkAccountCredit(accountDetails[0]?.id)

        setIsSending(false)

        if (accountCredit?.credit_balance !== 0) {
            // If user account contain credit

            SweetAlert.fire({
                showClass: {
                    popup: 'animate__animated animate__backInUp'
                },
                hideClass: {
                    popup: 'animate__animated animate__backOutDown'
                },
                title: `#${accountDetails[0]?.account_login} ${t("financial.contain")} $${accountCredit?.credit_balance} ${t("financial.credit")} `,
                html: `${t("financial.Type")} "<strong>${t("financial.AGREE")}</strong>" ${t("financial.toConfirm")} 
                          <br/>
                          <p style="color:red;margin-top:20px;">${t("financial.OnceYouConfirm")}  <strong>${t("financial.VOIDED")}</strong> ${t("financial.partiallyOrEntirely")} </p>
                          
                          <div>
                            <p style="margin-bottom:0px;"
                            >*${t("financial.KindlyTakeNote")}*</p>
                            <p>
                                1. ${t("financial.ByTypingAGREE")}
                                <br/>
                                2. ${t("financial.TheCreditWillOnly")}
                                <br/>
                                3. ${t("financial.IfYouHave")}<a href='/support'>${t("financial.customerService")}</a>. 

                            </p>
                          </div>
                          `,
                input: 'text',
                inputValue: '',
                inputPlaceholder: '',
                inputValidator: (result) => {
                    if (result.toLocaleLowerCase() !== 'agree' && result !== '同意') {
                        return t("financial.PleaseEnterThe")
                    }
                },
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t("financial.confirm"),
                cancelButtonText: t("financial.cancel"),
                reverseButtons: true,

            }).then(async (result) => {
                if (result.value) {
                    SweetAlert.fire({
                        showClass: {
                            popup: 'animate__animated animate__backInUp'
                        },
                        hideClass: {
                            popup: 'animate__animated animate__backOutDown'
                        },
                        title: `Step 3 : Final Agreement`,
                        html: `
                        
                        <div class="progress">
                            <div class="progress-bar bg-success" role="progressbar" aria-valuenow="3" aria-valuemin="0" aria-valuemax="3" style="width: 100%;"></div>
                         </div>
        
                        <div class='text-left' style="margin-top:20px;">
                            
                        <p>
                            ${t("pamm.I")}, ${userFullName}, ${t("pamm.understandAndAgree")} ...
                        </p>
        
                        <p>1. ${t("pamm.IfYouDecide")} <strong>${t("pamm.withdraw")}</strong> ${t("pamm.or")} <strong>${t("pamm.unsubscribe")}</strong> ${t("pamm.BesideSettlement")} <span style="color:red; font-weight: bold;">${t("pamm.deduct")} ${pammManagerDetails.penalty_percent}%</span> ${t("pamm.fromYourFund")}</p>
                        <p>2. ${t("pamm.ThisSettlementWillHappenOn")} <span style="font-weight: bold;">${settlementDate} (GMT +0) 00:00:00</span></p>
                        <p>3. ${t("pamm.TheInvestorIsNotAllowed")}
                        <br /><br />
                        ${t("pamm.TheInvestorWillBeAssigned")} <span style="color: green; font-weight: bold;">${t("pamm.afterTheSettlementDate")}</span> ${t("pamm.AsBufferPeriod")}
                        <br /><br />
                        ${t("pamm.ForExample")}
                        ${t("pamm.IfTheSettlementDateIsOn")} <span style="font-weight: bold;">${settlementDate} (GMT +0) 00:00:00</span>${t("pamm.theInvestorIsNotAllowed")} <span style="font-weight: bold;">${settlementDateTomorrow1} (GMT +0) 00:00:00</span> ${t("pamm.to")} <span style="font-weight: bold;">${settlementDateTomorrow2} (GMT +0) 23:59:59</span>${t("pamm.WithoutAnyPenalty")}
                        <p>
                            
                            <div class='text-left'>
                                <p style="margin-bottom:0px;">Learn More About <a href="${pammManagerDetails.lpoa_url}" target="_blank">LPOA Agreement</a></p>
                                <p>Learn More About <a href="${pammManagerDetails.op_url}" target="_blank">VE Fund Agreement</a></p>
                            </div>
        
                            <div class='text-left' style="margin-top:20px; color:red;">
                                <p style="margin-bottom:0px;">*${t("financial.KindlyTakeNote")}</p>
                                <p>1. ${t("pamm.YouWillReceiveAnPDF")}</p>
                            </div>
        
                            <div class='text-center'  style="margin-top:20px;">
                                ${t("financial.Type")} <strong>"${t("financial.AGREE")}"</strong> ${t("financial.toConfirm")}
                            </div>
                        </div>
                        </div>
                        `,
                        input: 'text',
                        inputValue: '',
                        inputPlaceholder: '',
                        inputValidator: (result) => {
                            if (result.toLocaleLowerCase() !== 'agree' && result !== '同意') {
                                return t("financial.PleaseEnterThe")
                            }
                        },

                        showCancelButton: true,
                        confirmButtonText: t('financial.confirm'),
                        cancelButtonText: t('financial.cancel'),
                        reverseButtons: true
                    }).then(async (result) => {
                        if (result?.value) {
                            try {
                                setIsSending(true)
                                if (data !== '') {
                                    const result = await PammService.create(pammId, {
                                        account_login: selectedAccount,
                                        is_voiding_credit: true
                                    })

                                    SweetAlert.fire({
                                        showClass: {
                                            popup: 'animate__animated animate__backInUp'
                                        },
                                        hideClass: {
                                            popup: 'animate__animated animate__backOutDown'
                                        },
                                        title: t("pamm.thankYouForYourApplication"),
                                        html: `${t("pamm.pleaseCheckYourApplicationStatus")}`,
                                        icon: 'success'
                                    }).then(function () {
                                        window.location.href = `/veFund`;
                                    })

                                    if (result.user) {
                                        reset()
                                        setError(null)

                                    }
                                    setIsSending(false)
                                } else {
                                    setIsSending(false)
                                    errors.showMessages()
                                }

                            } catch (error) {
                                //  SweetAlert.fire({
                                // showClass: {
                                //   popup: 'animate__animated animate__backInUp'
                                // },
                                // hideClass: {
                                //   popup: 'animate__animated animate__backOutDown'
                                // },
                                //     title: `${error.message}`,
                                //     icon: "error"
                                // })
                                const errorCode = error.code
                                const errorTranslate = error.translate_params
                                SweetAlert.fire({
                                    showClass: {
                                        popup: 'animate__animated animate__backInUp'
                                    },
                                    hideClass: {
                                        popup: 'animate__animated animate__backOutDown'
                                    },
                                    title: t(errorCode, errorTranslate),
                                    icon: 'error'
                                })
                                setError(error.message)
                                setIsSending(false)
                            }
                        }
                    })
                }
            })
        } else {
            // If user dont have credit, normal case

            SweetAlert.fire({
                showClass: {
                    popup: 'animate__animated animate__backInUp'
                },
                hideClass: {
                    popup: 'animate__animated animate__backOutDown'
                },
                title: `Step 3 : Final Agreement`,
                html: `
                
                <div class="progress">
                    <div class="progress-bar bg-success" role="progressbar" aria-valuenow="3" aria-valuemin="0" aria-valuemax="3" style="width: 100%;"></div>
                 </div>

                <div class='text-left' style="margin-top:20px;">
                    
                <p>
                    ${t("pamm.I")}, ${userFullName}, ${t("pamm.understandAndAgree")} ...
                </p>

                <p>1. ${t("pamm.IfYouDecide")} <strong>${t("pamm.withdraw")}</strong> ${t("pamm.or")} <strong>${t("pamm.unsubscribe")}</strong> ${t("pamm.BesideSettlement")} <span style="color:red; font-weight: bold;">${t("pamm.deduct")} ${pammManagerDetails.penalty_percent}%</span> ${t("pamm.fromYourFund")}</p>
                <p>2. ${t("pamm.ThisSettlementWillHappenOn")} <span style="font-weight: bold;">${settlementDate} (GMT +0) 00:00:00</span></p>
                <p>3. ${t("pamm.TheInvestorIsNotAllowed")}
                <br /><br />
                ${t("pamm.TheInvestorWillBeAssigned")} <span style="color: green; font-weight: bold;">${t("pamm.afterTheSettlementDate")}</span> ${t("pamm.AsBufferPeriod")}
                <br /><br />
                ${t("pamm.ForExample")}
                ${t("pamm.IfTheSettlementDateIsOn")} <span style="font-weight: bold;">${settlementDate} (GMT +0) 00:00:00</span>${t("pamm.theInvestorIsNotAllowed")} <span style="font-weight: bold;">${settlementDateTomorrow1} (GMT +0) 00:00:00</span> ${t("pamm.to")} <span style="font-weight: bold;">${settlementDateTomorrow2} (GMT +0) 23:59:59</span>${t("pamm.WithoutAnyPenalty")}
                <p>
                    
                    <div class='text-left'>
                        <p style="margin-bottom:0px;">Learn More About <a href="${pammManagerDetails.lpoa_url}" target="_blank">LPOA Agreement</a></p>
                        <p>Learn More About <a href="${pammManagerDetails.op_url}" target="_blank">VE Fund Agreement</a></p>
                    </div>

                    <div class='text-left' style="margin-top:20px; color:red;">
                        <p style="margin-bottom:0px;">*${t("financial.KindlyTakeNote")}</p>
                        <p>1. ${t("pamm.YouWillReceiveAnPDF")}</p>
                    </div>

                    <div class='text-center'  style="margin-top:20px;">
                        ${t("financial.Type")} <strong>"${t("financial.AGREE")}"</strong> ${t("financial.toConfirm")}
                    </div>
                </div>
                </div>
                `,
                input: 'text',
                inputValue: '',
                inputPlaceholder: '',
                inputValidator: (result) => {
                    if (result.toLocaleLowerCase() !== 'agree' && result !== '同意') {
                        return t("financial.PleaseEnterThe")
                    }
                },

                showCancelButton: true,
                confirmButtonText: t('financial.confirm'),
                cancelButtonText: t('financial.cancel'),
                reverseButtons: true
            }).then(async (result) => {

                if (result?.value) {
                    try {
                        setIsSending(true)
                        if (data !== '') {
                            const result = await PammService.create(pammId, {
                                account_login: selectedAccount,
                                is_voiding_credit: false
                            })

                            SweetAlert.fire({
                                showClass: {
                                    popup: 'animate__animated animate__backInUp'
                                },
                                hideClass: {
                                    popup: 'animate__animated animate__backOutDown'
                                },
                                title: t("pamm.thankYouForYourApplication"),
                                html: `${t("pamm.pleaseCheckYourApplicationStatus")}`,
                                icon: 'success'
                            }).then(function () {
                                window.location.href = `/veFund`;
                            })

                            if (result.user) {
                                reset()
                                setError(null)

                            }
                            setIsSending(false)
                        } else {
                            setIsSending(false)
                            errors.showMessages()
                        }

                    } catch (error) {
                        //  SweetAlert.fire({
                        // showClass: {
                        //     popup: 'animate__animated animate__backInUp'
                        // },
                        // hideClass: {
                        //     popup: 'animate__animated animate__backOutDown'
                        // },
                        //     title: `${error.message}`,
                        //     icon: "error"
                        // })
                        const errorCode = error.code
                        const errorTranslate = error.translate_params
                        SweetAlert.fire({
                            showClass: {
                                popup: 'animate__animated animate__backInUp'
                            },
                            hideClass: {
                                popup: 'animate__animated animate__backOutDown'
                            },
                            title: t(errorCode, errorTranslate),
                            icon: 'error'
                        })
                        setError(error.message)
                        setIsSending(false)
                    }
                }
            })
        }


    }

    const [userTypeName, setUserTypeName] = useState('')
    const [errorTypeName, setErrorTypeName] = useState(false)
    const [errorSelectedAcc, setErrorSelectedAcc] = useState('')

    const [alreadyBottom, setAlreadyBottom] = useState(false)

    const [onCheckInput, setOnCheckInput] = useState(false)
    const [onCheckError, setOnCheckError] = useState(false)

    const [LPOAbottom, setLPOAbottom] = useState(false)
    const [PAMMAgreementbottom, setPAMMAgreementbottom] = useState(false)

    const [showLPOAmodal, setShowLPOAmodal] = useState(false)
    const setLPOAToggleModal = () => {

        if (selectedAccount) {
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0

            setOnCheckInput(false)
            setErrorSelectedAcc('')
            setAlreadyBottom(false)
            setShowLPOAmodal(!showLPOAmodal)
            setUserTypeName('')
            setErrorTypeName(false)
            setLPOAbottom(false)
        } else {
            setErrorSelectedAcc('Please select MT5 Account')
            setOnCheckInput(false)
        }

    }

    const temporaryDisable = () => {

        SweetAlert.fire({
            showClass: {
                popup: 'animate__animated animate__backInUp'
            },
            hideClass: {
                popup: 'animate__animated animate__backOutDown'
            },
            title: 'Coming Soon',
            html: ``,
            icon: 'warning'
        })

    }

    const [showPAMMAgreement, setShowPAMMAgreement] = useState(false)

    const setPAMMAgreementToggleModal = () => {
        setOnCheckError(false)
        setShowPAMMAgreement(!showPAMMAgreement)
        setUserTypeName('')
        setErrorTypeName(false)
        setPAMMAgreementbottom(false)
    }

    const handleScroll = (e) => {
        const target = e.target

        if (target.offsetHeight + target.scrollTop >= target.scrollHeight) {
            setLPOAbottom(true)
            setPAMMAgreementbottom(true)
            setAlreadyBottom(true)
        }
    }

    const checkNameIsCorrect = () => {

        if (userTypeName.replace(/\s+/g, '') === userFullName.toLocaleUpperCase().replace(/\s+/g, '') && onCheckInput) {
            setUserTypeName('')
            setOnCheckInput(false)
            setOnCheckError(false)
            setErrorTypeName(false)
            setAlreadyBottom(false)
            setShowLPOAmodal(false)
            setPAMMAgreementbottom(false)
            setShowPAMMAgreement(true)
        } else {
            if (!onCheckInput) {
                setOnCheckError(true)
            } else {
                setOnCheckError(false)
            }

            if (userTypeName === userFullName.toLocaleUpperCase()) {
                setErrorTypeName(false)
            } else {
                setErrorTypeName(true)
            }
        }
    }

    const handleEnter = (e) => {

        if (e.key === 'Enter') {
            checkNameIsCorrect()
        }
    }

    const PAMMAgreementCheckNameIsCorrect = () => {

        if (userTypeName.replace(/\s+/g, '') === userFullName.toLocaleUpperCase().replace(/\s+/g, '') && onCheckInput) {
            setUserTypeName('')
            setOnCheckInput(false)
            setOnCheckError(false)
            setErrorTypeName(false)
            setAlreadyBottom(false)
            setShowLPOAmodal(false)
            setPAMMAgreementbottom(false)
            setShowPAMMAgreement(false)
            onSubmit()
        } else {
            if (!onCheckInput) {
                setOnCheckError(true)
            } else {
                setOnCheckError(false)
            }

            if (userTypeName === userFullName.toLocaleUpperCase()) {
                setErrorTypeName(false)
            } else {
                setErrorTypeName(true)
            }
        }
    }





    // get the Date without day

    let settlementDate
    let settlementDateTomorrow1
    let settlementDateTomorrow2

    if (pammManagerDetails.settlement_period == "Monthly") {
        if (moment().format('YYYY-MM-DD') != moment().startOf('month').format('YYYY-MM-DD')) {
            settlementDate = moment().add(1, 'M').startOf('month').format('YYYY-MM-DD')
            settlementDateTomorrow1 = moment().add(1, 'M').startOf('month').add(1, 'days').format('YYYY-MM-DD')
            settlementDateTomorrow2 = moment().add(1, 'M').startOf('month').add(2, 'days').format('YYYY-MM-DD')
        } else {
            settlementDate = moment().startOf('month').format('YYYY-MM-DD')
            settlementDateTomorrow1 = moment().startOf('month').add(1, 'days').format('YYYY-MM-DD')
            settlementDateTomorrow2 = moment().startOf('month').add(2, 'days').format('YYYY-MM-DD')
        }
    } else {
        settlementDate = moment(pammManagerDetails.settlement_date).format("YYYY-MM-DD")
        settlementDateTomorrow1 = moment(pammManagerDetails.settlement_date).add(1, 'days').format('YYYY-MM-DD')
        settlementDateTomorrow2 = moment(pammManagerDetails.settlement_date).add(2, 'days').format('YYYY-MM-DD')
    }




    return (
        <Container>
            <Breadcrumb title="VE Fund"><Link to="/pamm">VE Fund</Link> &nbsp; / {pammManagerDetails.name} - {t("pamm.subscribe")}</Breadcrumb>


            <Row style={{ margin: '0' }}>
                <Col xl='5' lg='6' md='7'>

                    <Card style={{ boxShadow: 'rgb(0 0 0 / 20%) 0px 4px 8px 0px' }}>
                        {/* <CardHeader>
                            <h4 style={{ color: '#C4A569' }}>{t("pamm.subscription")}</h4>
                            
                        </CardHeader> */}


                        {accounts?.length === 0 || accounts?.length == null ? (
                            <>
                                <Col style={{ margin: '30px', paddingRight: '40px' }}>
                                    <h4 style={{ color: '#113b58' }} className="mb-3">{t("pamm.youDoNotMeetTheRequirements")}</h4>
                                    <p>{t("pamm.pleaseMakeSureHaveAtLeastOneAvailable")}</p>
                                    <Link to={`/tradeAccount`}><Button className="mb-3">{t("pamm.openNewLiveAccount")}</Button></Link>
                                </Col>
                            </>
                        )

                            : <>
                                <FormGroup style={{ margin: '30px' }}>
                                    {isLoading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', top: '50%' }}><Spinner size="lg" /></div> :
                                        <div className="ml-3">

                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {/* <h4 style={{ color: '#113b58', fontWeight: '400', marginBottom: '20px' }} className="mb-3">{t("pamm.PAMMINFORMATION")}</h4> */}
                                                {/* <Link to={`/veFund/${id}/statistic`} style={{ borderRadius: '0 0 0 12px' }}>
                                                    <p style={{ position: 'absolute', right: '20px', top: '16px', textAlign: 'right', fontSize: '20px' }}>X</p>
                                                </Link> */}

                                            </div>


                                            <div style={{ marginBottom: '15px', textAlign: 'center' }}>
                                                <img src={pammManagerDetails?.avatar} alt='pamm avatar' style={{ width: '80px', height: '80px', borderRadius: '20px' }} />
                                            </div>



                                            <Row >
                                                <Col lg='12'>
                                                    <div style={{ display: "flex", justifyContent: 'center' }}>
                                                        {/* <p style={{ fontSize: '14px', marginBottom: '10px' }}><span>{t("pamm.Name")}</span></p> */}
                                                        <p style={{ fontWeight: '500', fontSize: '22px', fontWeight: '500' }}>{pammManagerDetails.name}</p>
                                                    </div>

                                                    <div style={{ display: "flex", justifyContent: 'center', marginTop: '-20px' }}>
                                                        <p style={{ fontSize: '16px' }}>{t('pamm.totalFundSize')} : {pammManagerDetails.statistics.fund_size} ++ </p>
                                                    </div>

                                                    <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                        <p style={{ fontSize: '16px', marginBottom: '10px', color: '#9099A3' }}><span >{t("pamm.minSubscription")}</span></p>
                                                        <p style={{ fontWeight: '500', fontSize: '16px' }}>{formatter.format(pammManagerDetails.min_amount)}</p>
                                                    </div>

                                                    {pammManagerDetails.performance_fee !== null ?
                                                        <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                            <p style={{ fontSize: '16px', marginBottom: '10px', color: '#9099A3' }}><span>{t("pamm.PerformanceFee")}</span></p>
                                                            <p style={{ fontWeight: '500', fontSize: '16px' }}>{pammManagerDetails.performance_fee} % </p>
                                                        </div> : ''}

                                                    {pammManagerDetails.management_fee !== null ?
                                                        <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                            <p style={{ fontSize: '16px', marginBottom: '10px', color: '#9099A3' }}><span >{t("pamm.ManagementFee")}</span></p>
                                                            <p style={{ fontWeight: '500', fontSize: '16px' }}>{pammManagerDetails.management_fee} % </p>
                                                        </div> : ''}
                                                </Col>

                                                {/* <Col lg='12'>
                                                    <p style={{ fontSize: '14px', marginBottom: '10px' }}><span style={{ fontWeight: '500' }}>{t("pamm.Name")}</span> {pammManagerDetails.name}</p>
                                                    <p style={{ fontSize: '14px', marginBottom: '10px' }}><span style={{ fontWeight: '500' }}>{t("pamm.minSubscription")}</span> {formatter.format(pammManagerDetails.min_amount)}</p>
                                                    {pammManagerDetails.performance_fee !== null ? <p style={{ fontSize: '14px', marginBottom: '10px' }}><span style={{ fontWeight: '500' }}>{t("pamm.PerformanceFee")}</span> {pammManagerDetails.performance_fee} % </p> : ''}
                                                    {pammManagerDetails.management_fee !== null ? <p style={{ fontSize: '14px', marginBottom: '10px' }}><span style={{ fontWeight: '500' }}>{t("pamm.ManagementFee")}</span> {pammManagerDetails.management_fee} %</p> : ''}
                                                </Col> */}

                                                <Col lg='12'>
                                                    {pammManagerDetails.flat_fee !== null ?
                                                        <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                            <p style={{ fontSize: '16px', marginBottom: '10px', color: '#9099A3' }}><span>{t("pamm.FlatFee")}</span></p>
                                                            <p style={{ fontWeight: '500', fontSize: '16px' }}>{formatter.format(pammManagerDetails.flat_fee)}</p>
                                                        </div> : ''}

                                                    <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                        <p style={{ fontSize: '16px', marginBottom: '10px', color: '#9099A3' }}><span>{t("pamm.SettlementPeriod")}</span></p>
                                                        <p style={{ fontWeight: '500', fontSize: '16px' }}>{pammManagerDetails.settlement_period}</p>
                                                    </div>

                                                    <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                        <p style={{ fontSize: '16px', marginBottom: '10px', color: '#9099A3' }}><span>{t("pamm.settlementDate")}</span></p>
                                                        <div style={{ textAlign: 'end', display: 'flex' }}>
                                                            <p style={{ fontWeight: '500', fontSize: '16px' }}>{settlementDate} (GMT +0)</p>

                                                            <HelpCircle id="nextSettlement" style={{ width: '14px', color: '#C4A569', marginLeft: '5px', cursor: 'pointer' }} />
                                                            <Tooltip id='settlementTooltip' placement='right' style={{ textAlign: 'left', backgroundColor: '#f7f7f7', color: 'black' }} isOpen={nextSettlementTooltipOpen} target="nextSettlement" toggle={nextSettlementToggle}>
                                                                <h5>{t("pamm.PleaseTakeNote")}</h5>
                                                                {/* <p>1. {t("pamm.SettlementDateSubscriber")} {pammManagerDetails.penalty_percent}%<strong></strong></p> */}
                                                                <p>1. {t("pamm.IfYouDecide")} <strong>{t("pamm.withdraw")}</strong> {t("pamm.or")} <strong>{t("pamm.unsubscribe")}</strong> {t("pamm.BesideSettlement")} <span style={{ color: 'red', fontWeight: 'bold' }}>{t("pamm.deduct")} {pammManagerDetails.penalty_percent}%</span> {t("pamm.fromYourFund")}</p>
                                                                <p>2. {t("pamm.ThisSettlementWillHappenOn")} {settlementDate} (GMT +0) 00:00:00</p>
                                                                3. {t("pamm.TheInvestorIsNotAllowed")}
                                                                <br /><br />
                                                                {t("pamm.TheInvestorWillBeAssigned")} <span style={{ color: 'green', fontWeight: 'bold' }}>{t("pamm.afterTheSettlementDate")}</span> {t("pamm.AsBufferPeriod")}
                                                                <br /><br />
                                                                {t("pamm.ForExample")}
                                                                {t("pamm.IfTheSettlementDateIsOn")} <span style={{ fontWeight: 'bold' }}>{settlementDate} (GMT +0) 00:00:00</span>{t("pamm.theInvestorIsNotAllowed")} <span style={{ fontWeight: 'bold' }}>{settlementDateTomorrow1} (GMT +0) 00:00:00</span> {t("pamm.to")} <span style={{ fontWeight: 'bold' }}>{settlementDateTomorrow2} (GMT +0) 23:59:59</span> {t("pamm.WithoutAnyPenalty")}
                                                            </Tooltip>

                                                        </div>
                                                    </div>

                                                    <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                        <p style={{ fontSize: '16px', marginBottom: '10px', color: '#9099A3' }}><span>{t("pamm.penalty")}</span></p>
                                                        <p style={{ fontWeight: '500', fontSize: '16px' }}>{pammManagerDetails.penalty_percent}%</p>
                                                    </div>

                                                </Col>
                                            </Row>


                                        </div>
                                    }

                                    {/* <div style={{ border: '1px solid #d9d9d9', marginLeft: '20px', marginRight: '20px' }}></div>

                                    <div className=" ml-3">
                                        <h4 style={{ color: '#113b58', fontWeight: 400 }} className="mt-3 mb-3">{t("pamm.selectMT5LIVEAccount")}</h4>
                                        <Input

                                            type="select"
                                            name="account_login"
                                            className="form-control digits"
                                            innerRef={register({ required: true })}
                                            id='selectPAMMinput'
                                            style={{ border: "1.5px solid #868686", marginBottom: '5px' }}
                                            required
                                            onChange={(e) => { setSelectedAccount(e.target.value) }}
                                        >
                                            <option value=''>{t("pamm.pleaseSelectAnAccount")}</option>

                                            {accounts?.length > 0 &&
                                                accounts.map((account, index) => {
                                                    return (
                                                        <option key={index} value={account.account_login} >{account.account_login} {account?.plan?.name} - {formatter.format(account?.balance)}</option>
                                                    )
                                                })}
                                        </Input> 

                                        {errorSelectedAcc && <p style={{ color: 'red' }}>{errorSelectedAcc}</p>}

                                        <FormGroup className="mb-0" style={{ float: 'right' }}>
                                            <Button onClick={() => { setLPOAToggleModal() }} color="primary" className="mt-1 mb-3" style={{ fontSize: '12px' }}>
                                                {t("pamm.Submit")}
                                            </Button>
                                            {isSending ? <Spinner className="ml-2" size="lg" /> : ''}
                                        </FormGroup>
                                    </div>
                                    */}


                                </FormGroup>

                            </>

                        }
                    </Card>
                </Col>

                {showLPOAmodal && selectedAccount && (
                    <Modal isOpen={showLPOAmodal} backdrop={true} centered={true}>

                        <ModalBody>
                            <div style={{ textAlign: 'center' }}>
                                <h4 style={{ fontWeight: '400' }}>{t("pamm.Step")} 1 : LPOA Agreement</h4>
                                <Progress color="primary" value="1" max="3" />
                            </div>

                            <Row style={{ justifyContent: 'center', marginTop: '20px' }}>
                                <Col id='scroll-bottom' lg='10' >

                                    <CardBody onScroll={(e) => handleScroll(e)} style={{ height: '400px', overflow: 'scroll', border: !alreadyBottom ? '1px solid red' : '1px solid green', borderRadius: '5px', textAlign: 'justify' }}>

                                        <LPOA />

                                    </CardBody>
                                    {!alreadyBottom && <p style={{ color: 'red', textAlign: 'center', marginBottom: '10px' }}>{t("pamm.MakeSureYouRead")}</p>}

                                    {alreadyBottom &&
                                        <Row style={{ marginTop: '10px', marginRight: '0', marginLeft: '25px' }}>
                                            <Input checked={onCheckInput} onChange={() => { setOnCheckInput(!onCheckInput) }} type='checkbox' required />
                                            <p style={{ marginBottom: '0' }}>{t("pamm.IUnderstandAndAgree")}</p>
                                        </Row>

                                    }
                                </Col>
                            </Row>

                            <Row style={{ marginTop: '20px' }}>
                                <Col style={{ textAlign: 'center' }}>
                                    {/* {console.log('userFullName.toLocaleUpperCase()', userFullName.toLocaleUpperCase())} */}
                                    <p style={{ fontSize: '14px' }}>{t("pamm.Type")} <strong>"{userFullName.toLocaleUpperCase()}"</strong> {t("pamm.asAgreeTo")}</p>
                                    <Input id='name-input' onChange={(e) => setUserTypeName(e.target.value)} type="text" style={{ width: '80%', margin: '0 auto', height: '2.625em', padding: '0 0.75em' }}></Input>
                                    {errorTypeName && <p style={{ marginBottom: '0px', color: 'red' }}>{t("pamm.PleaseTypeCorrect")}</p>}
                                    {onCheckError && <p style={{ marginBottom: '0px', color: 'red' }}>{t("pamm.PleaseMakeSure")}</p>}
                                </Col>
                            </Row>


                        </ModalBody>
                        <ModalFooter style={{ justifyContent: 'space-evenly' }}>
                            <Button onClick={setLPOAToggleModal} color="secondary">{t("pammSubsccription.Close")} </Button>
                            <Button disabled={!LPOAbottom} onKeyDown={handleEnter} onClick={() => checkNameIsCorrect()} color="primary">{t("pamm.Next")}</Button>
                            {/* <Button onKeyDown={handleEnter} onClick={() => checkNameIsCorrect()} color="primary">Next </Button> */}
                        </ModalFooter>

                        {/* {showLPOAmodal && localStorage.getItem('pamm-follow-onboarding') === null &&
                            <Steps
                                enabled={stepsEnabled}
                                steps={steps}
                                initialStep={0}
                                onExit={() => {
                                    localStorage.setItem('pamm-follow-onboarding', true)
                                    setStepsEnabled(false)
                                }}
                                options={
                                    {
                                        showProgress: true,
                                        doneLabel: 'Understand',
                                        exitOnOverlayClick: false
                                    }
                                }
                            />
                        } */}
                    </Modal>


                )}

                {showPAMMAgreement && selectedAccount && (
                    <Modal isOpen={showPAMMAgreement} backdrop={true} centered={true}>

                        <ModalBody>
                            <div style={{ textAlign: 'center' }}>
                                <h4 style={{ fontWeight: '400' }}>{t("pamm.Step")}  2 : VE Fund Agreement</h4>
                                <Progress color="primary" value="2" max="3" />
                            </div>

                            <Row style={{ justifyContent: 'center', marginTop: '20px' }}>
                                <Col lg='10' >

                                    <CardBody
                                        onScroll={(e) => handleScroll(e)}
                                        style={{
                                            height: '400px',
                                            overflow: 'scroll',
                                            border: !alreadyBottom ? '1px solid red' : '1px solid green',
                                            borderRadius: '5px',
                                            textAlign: 'justify'
                                        }}>

                                        <PammAgreement />

                                    </CardBody>
                                    {!alreadyBottom && <p style={{ color: 'red', textAlign: 'center', marginBottom: '10px' }}>{t("pamm.MakeSureYouRead")}</p>}

                                    {alreadyBottom &&
                                        <Row style={{ marginTop: '10px', marginRight: '0', marginLeft: '25px' }}>
                                            <Input checked={onCheckInput} onChange={() => { setOnCheckInput(!onCheckInput) }} type='checkbox' required />
                                            <p style={{ marginBottom: '0' }}>{t("pamm.IUnderstandAndAgree")}</p>
                                        </Row>

                                    }
                                </Col>
                            </Row>

                            <Row style={{ marginTop: '20px' }}>
                                <Col style={{ textAlign: 'center' }}>
                                    <p style={{ fontSize: '14px' }}>{t("pamm.Type")} <strong>"{userFullName.toLocaleUpperCase()}"</strong> {t("pamm.asAgreeTo")}</p>
                                    <Input onChange={(e) => setUserTypeName(e.target.value)} type="text" style={{ width: '80%', margin: '0 auto', height: '2.625em', padding: '0 0.75em' }}></Input>
                                    {errorTypeName && <p style={{ marginBottom: '0px', color: 'red' }}>{t("pamm.PleaseTypeCorrect")}</p>}
                                    {onCheckError && <p style={{ marginBottom: '0px', color: 'red' }}>{t("pamm.PleaseMakeSure")}</p>}
                                </Col>
                            </Row>


                        </ModalBody>
                        <ModalFooter style={{ justifyContent: 'space-evenly' }}>
                            <Button onClick={setPAMMAgreementToggleModal} color="secondary">{t("pammSubsccription.Close")} </Button>
                            <Button disabled={!PAMMAgreementbottom} onClick={() => PAMMAgreementCheckNameIsCorrect()} color="primary">{t("pamm.Next")} </Button>
                            {/* <Button onClick={() => PAMMAgreementCheckNameIsCorrect()} color="primary">Next </Button> */}
                        </ModalFooter>
                    </Modal>
                )}

                <Col xl='6' lg='5' md='4' style={{marginBottom:'70px'}}>
                    <Card style={{ boxShadow: 'rgb(0 0 0 / 20%) 0px 4px 8px 0px' }}>
                        {/*same if else, just need the condition */}
                        {accounts?.length === 0 || accounts?.length == null ? (
                            <>
                                <div></div>
                            </>
                        ) : (
                                <>
                                    <h5 style={{ margin: '20px 0px 0px 20px' }}>{t("financial.KindlyTakeNote")}</h5>
                                    <Card style={{ backgroundColor: '#F0F0F0', margin: '20px' }}>

                                        <Row className='p-l-20 pt-2'>
                                            <Col lg='1' md='1' xs='1' style={{ textAlign: 'center' }}>
                                                <span
                                                    style={{
                                                        height: '23px',
                                                        width: '23px',
                                                        backgroundColor: ' #C4A569',
                                                        borderRadius: '50%',
                                                        display: 'inline-block',
                                                        textAlign: 'center',
                                                        marginTop: '5px'
                                                    }}>
                                                    <p>1</p>
                                                </span>
                                            </Col>
                                            <Col>
                                                <p className='mt-1'>
                                                    {t("pamm.SettlementWillBeProceed")}
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row className='p-l-20 pt-2'>
                                            <Col lg='1' md='1' xs='1' style={{ textAlign: 'center' }}>
                                                <span
                                                    style={{
                                                        height: '23px',
                                                        width: '23px',
                                                        backgroundColor: ' #C4A569',
                                                        borderRadius: '50%',
                                                        display: 'inline-block',
                                                        textAlign: 'center',
                                                        marginTop: '5px'
                                                    }}>
                                                    <p>2</p>
                                                </span>
                                            </Col>
                                            <Col>
                                                <p className='mt-1'>
                                                    {t("pamm.PenaltyWillBeChargedIf")}
                                                </p>
                                            </Col>
                                        </Row>

                                    </Card>
                                    <Card style={{ padding: '20px', margin: '20px', boxShadow: 'rgb(0 0 0 / 5%) 0px 4px 8px 0px' }}>
                                        <h5 style={{ color: '#113b58', fontWeight: 500 }} className="mt-3 mb-3">{t("pamm.selectMT5LIVEAccount")}</h5>
                                        {errorSelectedAcc && <p className='m-0 p-0' style={{ color: 'red' }}>{errorSelectedAcc}</p>}
                                        <Input

                                            type="select"
                                            name="account_login"
                                            className="form-control digits"
                                            innerRef={register({ required: true })}
                                            id='selectPAMMinput'
                                            style={{ border: 'none', borderRadius: '14px', height: '50px', marginBottom: '5px', backgroundColor: '#F7F7F7', width: '100%' }}
                                            required
                                            onChange={(e) => { setSelectedAccount(e.target.value) }}
                                        >
                                            <option value=''>{t("pamm.pleaseSelectAnAccount")}</option>

                                            {accounts?.length > 0 &&
                                                accounts.map((account, index) => {
                                                    return (
                                                        <option key={index} value={account.account_login} >{account.account_login} {account?.plan?.name} - {formatter.format(account?.balance)}</option>
                                                    )
                                                })}
                                        </Input>
                                    </Card>

                                </>
                            )}
                    </Card>
                    <FormGroup className="mb-0" style={{ width: '100%' }}>
                        {accounts?.length === 0 || accounts?.length == null ? (
                            <>
                                <div></div>
                            </>
                        ) : (

                                <Card onClick={() => {
                                    // temporaryDisable()
                                    setLPOAToggleModal()
                                }} className="mt-1 mb-3" style={{ fontSize: '18px', cursor: 'pointer', backgroundColor: ' #C4A569', borderRadius: '20px', height: '55px', justifyContent: 'center', textAlign: 'center' }}>
                                    {t("pamm.Submit")}
                                </Card>
                            )
                        }
                        {isSending ? <Spinner className="ml-2" size="lg" /> : ''}
                    </FormGroup>
                </Col>


            </Row>



        </Container>
    )
}

export default PammFollow